export const THREAD_PAUSED_ON_GENERIC_CHANNEL = 'THREAD_PAUSED_ON_GENERIC_CHANNEL';